import moment from 'moment-timezone';
import {useNavigate} from 'react-router-dom';

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AppointmentSummary from './AppointmentSummary';
import CustomBox from '../common/CustomBox';

const AppointmentSuccessScreen = props => {
  const navigate = useNavigate();
  const {appointment, patientId, isProvider} = props;
  const provider = appointment?.provider;
  const sessionType = appointment?.session_type;
  const sessionId = appointment?.session?.id;
  const url = (
    isProvider 
    ? `/providers/sessions/view/${sessionId}`
    : `/clients/sessions/view/${sessionId}`
  );
  return (
    <Container maxWidth='md'>
      <Stack alignItems='center'>
        <CustomBox>
          <Stack padding={2} spacing={4} alignItems='center'>
            <Typography variant='h1'>
              Appointment Confirmation
            </Typography>
            {
              appointment
                ? <div><AppointmentSummary
                  provider={provider}
                  sessionType={sessionType}
                  datetime={moment.tz(appointment?.start_time, provider?.timezone || moment.tz.guess())}
                /></div>
                : null
            }
            {isProvider ? null : 
              <Typography variant='large500Tight'>
                We’re looking forward to helping you meet your goals!
              </Typography>
            }
            {isProvider ? null :
              <Typography variant='large500Tight'>
                You'll recieve an email soon with a calendar invitation.
              </Typography>
            }
            <Stack spacing={.5}>
              <Button
                variant='primaryGradient'
                size='medium'
                onClick={() => navigate('/')}
              >
                Done
              </Button>
              <Button 
                variant='text' 
                size='small'
                onClick={() => navigate(url)}
              >
                View Details
              </Button>
            </Stack>
          </Stack>
        </CustomBox>
      </Stack>
    </Container>
  );
};

export default AppointmentSuccessScreen;
